import { initializeOrderAtTable } from './actions/initialize-order-at-table';
import { getTableOrder } from './actions/get-table-order';
import { getTableOrders } from './actions/get-table-orders';
import { setTableOrder } from './actions/set-table-order';
import { getTableTickets } from './actions/get-table-tickets';
import { getTableTicket } from './actions/get-table-ticket';
import { setTableOrders } from './actions/set-table-orders';
import { stageUpsellItems } from './actions/stage-upsell-items';
import { addStagedItemsToOrder } from './actions/add-staged-items-to-order';


const orderAtTable = {
  namespaced: true,

  actions: {
    initializeOrderAtTable,
    getTableOrder,
    setTableOrder,
    getTableOrders,
    getTableTicket,
    getTableTickets,
    setTableOrders,
    stageUpsellItems,
    addStagedItemsToOrder
  }
};

export { orderAtTable };

